module.exports = __webpack_public_path__ + "img/dis.66c403e5.jpg";